var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeDModel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 60 60",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_95",
    "data-name": "Layer 95"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m58.72 18.2a2 2 0 0 0 -1-1.65l-24.72-14.28a2 2 0 0 0 -2 0l-24.73 14.28a2 2 0 0 0 -1 1.73v27.44a2 2 0 0 0 1 1.73l24.73 14.28a2 2 0 0 0 2 0l24.73-14.28a2 2 0 0 0 1-1.73v-27.44s-.01-.05-.01-.08zm-26.72-11.89 20.73 12-20.73 11.94-20.73-12zm-22.73 15.43 20.73 11.97v22.83l-20.73-12zm24.73 34.8v-22.83l20.73-12v22.86z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDModel);
export default __webpack_public_path__ + "static/media/threeD_model.58a5fafa7a5b4701bbe08a595e5cf444.svg";
export { ForwardRef as ReactComponent };